import { motion, useReducedMotion, type HTMLMotionProps } from "framer-motion";
import { fadeUp } from "./presets";

interface RevealProps extends HTMLMotionProps<"div"> {
  delay?: number;
  amount?: number;
  once?: boolean;
}

export function Reveal({
  delay = 0,
  amount = 0.2,
  once = true,
  children,
  variants = fadeUp,
  transition,
  ...rest
}: RevealProps) {
  const reduced = useReducedMotion();
  return (
    <motion.div
      initial={reduced ? false : "hidden"}
      whileInView="show"
      viewport={{ once, amount }}
      variants={variants}
      transition={{ delay, ...(transition ?? {}) }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}